
import {TextInput, Button} from '@burna/monster-design-system';
import {Link} from 'react-router-dom';
import styles from './index.module.scss';

function InputField({text}) {
  const downloadUrl = text.replace(/(?!^) (?!$)/g, '%20');

  return (
    <div className={styles.container}>
      <TextInput
        className={styles.input}
        value={downloadUrl}
        readOnly
      />
      <Button
        as={Link}
        to={downloadUrl.slice(downloadUrl.indexOf('/download'))}
        icon="download"
        iconPlacement="trailing"
        text="Download"
      />
    </div>
  );
}

export default InputField;
